import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import * as moment from 'moment-timezone';
import { Router } from '@angular/router';
import { CommonServiceService } from '../../common-service.service';
import { GlobalVariable } from '../../global-variable';
import { Store } from '@ngrx/store';
import { InitialState } from 'src/app/store/reducer';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['../global-search.component.scss']
})
export class AuditTrailComponent implements OnInit {

  auditTrailForm!: FormGroup;

  @ViewChild('searchButton', { static: true }) searchButton!: ElementRef;

  minDate = "2026-04-01";
  maxDate = moment().format('YYYY-MM-DD');
  
  dateFormat = 'YYYY-MM-DD';
  isLocaleDateFormat = true;

  constructor( 
    public commonService: CommonServiceService,
    private formBuilder: FormBuilder , 
    private router: Router,
    private store: Store<InitialState>
  ) {
      this.store.select('sharedReducers').subscribe((items)=>{
        if(items.financeYear && items.financeYear.start_date && items.financeYear.end_date){
          this.minDate = items.financeYear.start_date
          this.maxDate = this.commonService.getFinancialSession(moment(items.financeYear.end_date)) < this.commonService.getFinancialSession(moment()) ? 
                      moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        } else {
          let current_financial_year =  JSON.parse(sessionStorage.getItem('current_financial_year'))
          if(!current_financial_year) {
            current_financial_year = JSON.parse(localStorage.getItem('current_financial_year'));
          }
          this.minDate = current_financial_year.start_date
          this.maxDate = this.commonService.getFinancialSession(moment(current_financial_year.end_date)) < this.commonService.getFinancialSession(moment()) ? 
                      moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        }
        
    })
  }

  ngOnInit(): void {
    console.log('maxDate', this.maxDate);
    this.auditTrailForm = this.formBuilder.group({  
      start_date: [this.minDate, this.checkDate('start_date')],
      end_date: [this.maxDate, this.checkDate('end_date')]
    });
  }

  checkDate(formControlName) {
    return (control: AbstractControl) => {
      let valid = true
      if (!moment(control.value, 'YYYY-MM-DD').isValid()) {
        valid = false
      } else {
        if (this) {
          if (moment(control.value).isBefore(moment(this.minDate, 'YYYY-MM-DD')) || moment(control.value).isAfter(moment(this.maxDate, 'YYYY-MM-DD'))) {
            valid = false
          }
        }
      }

      return !valid ? { [formControlName]: { value: control.value } } : null;
    };
  }

  search(values: any) {
    GlobalVariable.openModalStatus = false;

    const startDate = moment(values.start_date).format('YYYY-MM-DD');
    const endDate = moment(values.end_date).format('YYYY-MM-DD');

    this.router.navigateByUrl(
      `/report/audit-trail-list?start_date=${startDate}&end_date=${endDate}`
    );
  }

  reset() {
    this.auditTrailForm.reset({
      start_date: this.minDate,
      end_date: this.maxDate
    });
  }

  clickSearchButton() {
    this.searchButton.nativeElement.click();
  }
}